import React from 'react';
import { Button } from './Button';
import { Check } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-black relative overflow-hidden" data-id="element-92">
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-gold-dark/10 via-black to-black pointer-events-none" data-id="element-93"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-94">
        <div className="text-center mb-16" data-id="element-95">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight" data-id="element-96">
            Next Monday you could still be building your classes from scratch...
            <br data-id="element-97" />
            <span className="text-gold-gradient" data-id="element-98">
              Or you could walk into the studio with everything ready — from
              today.
            </span>
          </h2>

          <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-dark-card p-8 rounded-2xl border border-dark-border" data-id="element-99">
            {['No more Sunday nights searching for drills, combinations, and warm-ups that actually work', 'No more classes that feel rushed, repetitive, or underprepared', 'No more students losing motivation because every session feels the same', 'No more weekends spent planning instead of resting and living your life', 'No more walking into the studio wishing you had prepared more'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-100">
                <span className="text-gold mt-1" data-id="element-101">▸</span>
                <span className="text-gray-300" data-id="element-102">{item}</span>
              </div>)}
          </div>

          <p className="text-xl text-white mb-2" data-id="element-103">
            Dance Technique Teacher Ready™ doesn't make you a better teacher.
          </p>
          <p className="text-2xl font-bold text-gold mb-6" data-id="element-104">
            You're already a great teacher.
          </p>
          <p className="text-xl text-gray-300 mb-16" data-id="element-105">
            What Dance Technique Teacher Ready™ does is give you the time and
            the tools to make that visible — in every single class you teach.
          </p>
        </div>

        <div className="bg-black border-2 border-gold/30 rounded-3xl p-8 md:p-12 shadow-[0_0_40px_rgba(212,175,55,0.1)]" data-id="element-106">
          <h3 className="text-2xl font-bold text-white mb-6 text-center border-b border-dark-border pb-6" data-id="element-107">
            Everything That's Included:
          </h3>

          <div className="grid md:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-id="element-108">
            {['100 ready-to-teach dance classes', '35 Jazz · 35 Contemporary · 30 Musical Theatre', '40+ weeks of fresh content without repeating', 'Every class fully structured from warm-up to cooldown', 'Teaching cues, corrections, and progressions included', 'Bonus 1 — 52-Week Dance Teaching Planner', 'Bonus 2 — Ultimate Cueing & Correction Library', 'Bonus 3 — 30 Emergency Dance Classes', 'Bonus 4 — Music, Counts & Tempo Guide', 'Bonus 5 — Student Progress & Assessment Toolkit', '7-Day Money-Back Guarantee', 'Immediate Access', 'Pay in your local currency', 'PDF format — ready to use'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-109">
                <Check size={18} className="text-gold shrink-0" data-id="element-110" />
                <span className="text-sm text-gray-200" data-id="element-111">{item}</span>
              </div>)}
          </div>

          <div className="text-center" data-id="element-112">
            <div className="mb-8 p-6 bg-gold/5 rounded-xl border border-gold/20 italic text-gray-300 text-lg" data-id="element-113">
              "The best time to have this teaching library was before your very
              first class.
              <br data-id="element-114" />
              <span className="text-gold font-bold not-italic" data-id="element-115">
                The second best time is today.
              </span>
              "
            </div>

            <p className="text-xl font-serif font-bold text-white mb-2" data-id="element-116">
              💃 Dance Technique Teacher Ready™
            </p>
            <p className="text-sm text-gray-400 mb-8" data-id="element-117">
              100 ready-to-teach Jazz, Contemporary & Musical Theatre classes —
              built to help dance teachers plan less, teach with confidence, and
              keep every session fresh.
            </p>

            <Button href="https://dance-technique-teacher-ready.impultienda.ar/checkout" target="_blank" onLinkClick={() => {
            if (typeof window !== 'undefined' && (window as any).fbq) {
              ;
              (window as any).fbq('track', 'InitiateCheckout', {
                content_name: 'Dance Technique Teacher Ready Complete Pack',
                value: 27.0,
                currency: 'USD'
              });
            }
          }} className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-118">
              🟡 GET THE COMPLETE TEACHING LIBRARY NOW
            </Button>

            <div className="flex flex-wrap justify-center gap-4 text-xs text-gray-500" data-id="element-119">
              <span data-id="element-120">✅ 7-Day Money-Back Guarantee</span>
              <span data-id="element-121">✅ Secure Payment</span>
              <span data-id="element-122">✅ Immediate Access</span>
              <span data-id="element-123">✅ Pay in Your Local Currency</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}